export default __webpack_public_path__ + "static/media/LEGA8986.b42a143e.jpg";